import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TesteService } from 'src/app/services/teste.service';
import { Router } from '@angular/router';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-administra',
  templateUrl: './administra.component.html',
  styleUrls: ['./administra.component.scss']
})
export class AdministraComponent implements OnInit {

  form: FormGroup;
  cod_area:string;
  desc_area:string;
  mm_curso: string;
  combo_curso: string;



  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });


  panelOpenState = false;

  listagem = [];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  colunas = ['classificacao', 'cpf', 'nome', 'curso', 'status', 'acao' ];


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private testeService: TesteService, private matDialod: MatDialog, private _snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.initForm();
    this.form.get("curso").setValue(this.testeService.pub_curso);
    this.criarFiltro();

    this.cod_area = this.testeService.pub_area;
    if (this.cod_area == '39'){
      this.desc_area = "ENSINO MEDICO";
    }
    if (this.cod_area == '64'){
      this.desc_area="ENSINO MULTIPROFISSIONAL";
    }
    if (this.cod_area == '40'){
      this.desc_area = "ENSINO DE ENFERMAGEM";
    }
    if (this.cod_area=='41'){
      this.desc_area="ENSINO TECNICO";
    }




    this.testeService.listarPorArea().then((data: any) => {console.log(data);
      // this.listagem = data;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.data = data;
      this.customDataSource();
    });

  }

  abrirDialog() {
    this.matDialod.open(DialogComponent);
  }




  abrirSnack() {
    this._snackBar.open('Snackbar gerado com sucesso', 'OK', {
      horizontalPosition: 'end',
      verticalPosition: 'top',
    });
  }

  customDataSource() {
    this.paginator._intl.itemsPerPageLabel = 'Itens por página:';
  }



  goToConvoca(param: any) {
    this.testeService.pub_inscricao = param;
    this.testeService.pub_cpf= param.cpf;

    if(confirm("Confirma a Convocação do candidato?")){

       if (param.status=="CLASSIFICADO"){
        // muda status para CONVOCADO
          this.testeService.alteraStatus(param.cpf, "CONVOCADO" );

          // envia email convocando
          //const desti = param.email;
          const reme = "teste@inca.gov.br";
          const desti = "jose.pacheco@ctis.com.br";
          const titulo = "Confirmação de Convocação para Pre-inscrição";
          const mens = "Confirmação de Convocação para processo de pre-inscricao";
          this.testeService.enviaEmail(reme, desti, titulo, mens);


          /// navega para a ANALISE
          this.testeService.listarPorArea().then((data: any) => {console.log(data);
            // this.listagem = data;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.dataSource.data = data;
            this.customDataSource();
          });
      }else{
        //avisa Operação indevida
        window.prompt('Acesso Negado','STATUS NÃO PERMITE CONVOCAÇÃO!');
      }
  }

  }



  goToAnalise(param: any) {
    /// carrega o objeto para o service
    this.testeService.pub_inscricao = param;
    this.testeService.pub_cpf= param.cpf;
    /// navega para a ANALISE
    this.router.navigate(['/analise'])
  }

  goToEmail(param: any) {
    /// carrega o objeto para o service
    this.testeService.pub_inscricao = param;
    /// navega para a email
    this.router.navigate(['/comunicacao']);
  }

  initForm() {
    this.form = this.fb.group({
      classificacao:'',
      prontuario: '',
      nome: '',
      cpf: '',
      nascimento: '',
      idade: '',
      sexo: '',
      cns: '',
      status: '',
      unidade: '',
      start: '',
      end: '',
      curso:''
    });
  }


  criarFiltro() {

    this.mm_curso = this.form.get('curso').value;
    this.testeService.pub_curso = this.mm_curso;
    console.log('FILTRO ==============', this.mm_curso);

    if (this.mm_curso==''){
    this.testeService.listarPorArea().then((data: any) => {console.log(data);
    console.log('FILTRADO AREA ==========', this.mm_curso);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.data = data;
    this.customDataSource();

    });
    }else{
      this.testeService.listarPorArea().then((data: any) => {console.log(data);
        console.log('FILTRADO CURSO ========', this.mm_curso);
        this.testeService.pub_curso= this.mm_curso;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.data = data;
        this.customDataSource();

        });

    }

  }
  retorna(){
    // navega para a tela de login
    this.router.navigate(['/']);

  }


}

